export default {
  logo: {
    label: 'Logo',
    tooltip: 'Vybrané logo sa zobrazuje v hlavičke každého reportu.',
  },
  errors: {
    unsupportedFileType: 'Aktuálne logo je v nepodporovanom formáte súboru. Nahrajte nové logo.',
    logoLoadingFailure: 'Aktuálne logo sa nepodarilo načítať. Odporúčame nahrať nové logo.',
  },
};
